module.exports = __webpack_public_path__ + "img/JobInfo.c3a2a22a.svg";